import React from "react";
import { Link } from "react-router-dom";
import Bg from "../../assets/img/bg/aliment-left.png";

const services = [
  {
    id: 1,
    icon: "flaticon flaticon-customer-support",
    title: "Technical Services",
    description:
      "Donec vestibulum arcu a arcu scelerisque, quis dignissim turpis semper onec tortor mi, volutpat a iaculis sit amet.",
  },
  {
    id: 2,
    icon: "flaticon flaticon-solar-panel",
    title: "Energy Panels",
    description:
      "Donec vestibulum arcu a arcu scelerisque, quis dignissim turpis semper onec tortor mi, volutpat a iaculis sit amet.",
  },
  {
    id: 3,
    icon: "flaticon flaticon-wind-energy",
    title: "Wind Generators",
    description:
      "Donec vestibulum arcu a arcu scelerisque, quis dignissim turpis semper onec tortor mi, volutpat a iaculis sit amet.",
  },
  {
    id: 4,
    icon: "flaticon flaticon-eco-home",
    title: "Solar As A Service",
    description:
      "Donec vestibulum arcu a arcu scelerisque, quis dignissim turpis semper onec tortor mi, volutpat a iaculis sit amet.",
  },
  {
    id: 5,
    icon: "flaticon flaticon-charging-station",
    title: "Solar PV Systems",
    description:
      "Donec vestibulum arcu a arcu scelerisque, quis dignissim turpis semper onec tortor mi, volutpat a iaculis sit amet.",
  },
  {
    id: 6,
    icon: "flaticon flaticon-clipboard",
    title: "Inspection Checklist",
    description:
      "Donec vestibulum arcu a arcu scelerisque, quis dignissim turpis semper onec tortor mi, volutpat a iaculis sit amet.",
  },
];

function Services() {
  return (
    <>
      <section id="services-08" className="services-08 pb-120 p-relative" style={{backgroundImage: `url(${Bg})`,backgroundRepeat: "no-repeat", backgroundPosition: "left center",}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title center-align mb-50 text-center">
                <h5>OUR SERVICES</h5>
                <h2>What We Offer</h2>
              </div>
            </div>
          </div>
          <div className="row services-08-item--wrapper mt-0">
            {services.map((service) => (
              <div className="col-lg-4 col-md-4" key={service.id}>
                <div className="services-08-item">
                  <div className="services-08-thumb">
                    <i className={service.icon} />
                  </div>
                  <div className="services-08-content">
                    <h3>
                      <Link to="/Servicedeatils">{service.title}</Link>{" "}
                    </h3>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;